import React from 'react'
import {Link} from 'react-router-dom'
import Card from 'react-bootstrap/Card';
import '../deal.css'

function PrimeCard() {
  return (
    <Card style={{ width: '25rem' }}>
    <Card.Img variant="top" src="/PrimeDay.png" style={{height:"75%"}} />
    <Card.Body>
     <Link to="/myblog/primeday">
      amazon’s october prime day is about to come and we find these deals so far
      </Link>
    </Card.Body>
  </Card>
      );
    }


export default PrimeCard